import React, {useState} from 'react';
import {useField, useFormikContext} from 'formik';

import {Column} from '../layout';
import ErrorMessage from './ErrorMessage';
import './styles.scss';
import AppDateInput from '../input/app-date-input';
import moment from 'moment';
import AppDateCustomInput from '../input/app-date-input/AppDateCustomInput';

interface AppFormDatePickerFieldProps
  extends React.HTMLProps<HTMLInputElement> {
  name: string;
  showErrorMessage?: boolean;
  className?: string;
  onChange?(value: any): void;
  handleFormikContext?(formik: any): void;
  noCalendar?: any;
  minDate?: Date;
  selectedValue?: Date;
  maxDate?: Date;
  setHoverError?: any;
  custom?: boolean;
  isLoading?: boolean;
  firstDateAvailable?: any;
  doctorAvailableSlots?: any[];
  doctorAvailableSlotsFromToday?: any[];
  dontShowYears?: boolean;
  getAvailableSlotsByTime?(sD: any, sT: any, eD: any, eT: any): void;
  defaultColor?: boolean;
}

function AppFormDatePickerField({
  name,
  showErrorMessage = false,
  placeholder,
  className,
  noCalendar,
  defaultColor = false,
  isLoading = true,
  firstDateAvailable,
  handleFormikContext,
  onChange,
  minDate,
  maxDate,
  selectedValue,
  custom,
  doctorAvailableSlots,
  doctorAvailableSlotsFromToday,
  dontShowYears,
  getAvailableSlotsByTime,
}: AppFormDatePickerFieldProps) {
  const formik = useFormikContext();
  const {setFieldTouched, errors, touched, setFieldValue, values} = formik;
  const error = (errors as any)[name];
  const visible = (touched as any)[name];
  const [showDefaultValue, setShowDefaultValue] = useState(true);

  const [field] = useField(name);

  if (!!handleFormikContext) {
    handleFormikContext(formik);
  }
  const handleOnChange = (value: any) => {
    setShowDefaultValue(false);
    if (onChange) {
      onChange(value);
      setFieldValue(name, value);
      setFieldTouched(name);
    } else {
      setFieldValue(name, value);
      setFieldTouched(name);
    }
  };

  return (
    <Column className="app-form-date-picker-container">
      {!custom && (
        <AppDateInput
          className={className}
          value={field.value}
          selected={
            selectedValue && showDefaultValue
              ? moment(selectedValue).toDate()
              : field.value
          }
          defaultColor={defaultColor}
          noCalendar={noCalendar}
          onChange={(value: any) => handleOnChange(value)}
          onBlur={() => setFieldTouched(name)}
          placeholder={placeholder}
          minDate={minDate}
          error={!(values as any)[name] && error && visible}
          maxDate={maxDate}
          dontShowYears={dontShowYears}
        />
      )}
      {custom && (
        <AppDateCustomInput
          className={className}
          value={field.value}
          selected={
            selectedValue && showDefaultValue
              ? moment(selectedValue).toDate()
              : field.value
          }
          defaultColor={defaultColor}
          noCalendar={noCalendar}
          onChange={(value: any) => handleOnChange(value)}
          onBlur={() => setFieldTouched(name)}
          placeholder={placeholder}
          minDate={firstDateAvailable || minDate}
          error={!(values as any)[name] && error && visible}
          maxDate={maxDate}
          isLoading={isLoading}
          doctorAvailableSlots={doctorAvailableSlots || []}
          doctorAvailableSlotsFromToday={doctorAvailableSlotsFromToday || []}
          getAvailableSlotsByTime={(sD: any, sT: any, eD: any, eT: any) =>
            getAvailableSlotsByTime && getAvailableSlotsByTime(sD, sT, eD, eT)
          }
        />
      )}

      {showErrorMessage && <ErrorMessage error={error} visible={visible} />}
    </Column>
  );
}

export default AppFormDatePickerField;
